/*eslint-disable */
import React from "react";
import { AccountHeader } from "@treatwell/front-end-2.0";
import ReactDOM from "react-dom";

define(function (require) {
  var $ = require("jquery");
  var modalWindow = require("site/mobile/modal-window");
  var googleAnalyticsEvents = require("site/mobile/analytics/mobile-google-analytics-events");
  var jqueryMobileLoader = require("site/mobile/jquery-mobile-loader");
  var logInHandler = require("site/mobile/log-in-handler");
  var localStoragePolifill = require("common/localStorage-polifill");

  const config = require("common/page-config");

  require("site/mobile/jquery-mobile-init");

  localStoragePolifill.initialise();
  $.noConflict();

  jqueryMobileLoader(function () {
    googleAnalyticsEvents.addListeners();
    $.mobile.initializePage();
    logInHandler.setUp(false, "#signin-page");
    logInHandler.addTrackingEventListeners("loginPage");
    modalWindow.hide();
  });

  ReactDOM.render(
    
      <AccountHeader
        showBackButton
        backUri={"/"}
        backLabel={config.homeLabel}
        onBackClick={() => {}}
        logoUri={"/"}
        onLogoClick={() => {}}
      />,
    document.getElementById("account-header")
  );
});
